import { IRouteObj } from "interface/common";
import React from "react";
import PageUploadAudio from "view/PageUploadAudio/PageUploadAudio";

//base
export const linkBasePath = "/dashboard";
export const linkApiBasePath = "/api";
/** Base path for Bluejay PD Abstraction FastAPI router */
export const linkBluejayApiBase = "/synthia/ai/bluejay/pd-abstraction";
export const linkAppDBApiBase = "synthia/ai/appdb/v1";

//No Auth Routes
export const linkPageBase = "/";
export const linkPageLogin = "/login";
export const linkPageSignup = "/sign-up";
export const linkPageVerifyOTP = "/verify-otp";
export const linkPageForgotPassword = linkPageLogin + "/forgot-password";
export const linkPagePasswordReset = linkPageLogin + "/reset-password";
export const linkPageSSOCallback = "/sso-callback";
export const linkPageLoading = "/loading";
// export const linkPageUploadPDF = "/upload-pdf";
export const linkPageUploadAudio = "/upload-audio";
export const linkPageIntelligence = "/intelligence/:uuid";
// export const linkPageRebateAnalysis = "/rebate-analysis";
export const linkPageAudioAnalysis = "/audio-analysis";
export const linkPageUnauthorized = "/unauthorized";

//links
export const linkAuthRoute = "/console";
export const linkPageMenu = "/menu";
export const linkPageView1 = "/view1";
export const linkPageView2 = "/view2";
export const linkPageView3 = "/view3";
export const linkPageView4 = "/view4";
export const linkPageCart = "/cart";
export const linkPageFormNameCreate = "/formname/create";
export const linkPageFormNameView = "/formname/view/:uid"; //? add this to make it optional
export const linkPageBranchCreate = "/branch/create";
export const linkPageBranchView = "/branch/view/:uid"; //? add this to make it optional
export const linkPageMode = "/mode";
export const linkPageCreateProjectCreate = "/project/create";
export const linkPageCreateProjectView = "/project/view/:uid";
export const linkNamePageCreateProject = "CreateProject";
export const linkPageProjectListing = "/project-listing";
export const linkPageDashboard = "/dashboard";
export const linkPageHost = "/host";
export const linkPageLaunch = "/launch";
export const linkPageAdmin = "/admin";
export const linkPageEditor = "/editor";

//linknames
export const linkNamePageLogin = "Login";
export const linkNamePageMenu = "Menu";
export const linkNamePageView1 = "View1";
export const linkNamePageView2 = "View2";
export const linkNamePageFormAutomation = "FormAutomation";
export const linkNamePageBranch = "Branch";
export const linkNamePageProjectListing = "PageProjectListing";
export const namePageDashboard = "Dashboard";
export const linkNamePageHost = "Host";
export const linkNamePageLaunch = "Launch";
export const linkNamePageAdmin = "Admin";
export const linkNamePageUploadPDF = "UploadPDF";
export const linkNamePageIntelligence = "Intelligence";
export const linkNamePageRebateAnalysis = "RebateAnalysis";
export const linkNamePageUnauthorized = "Unauthorized";
export const linkNamePageEditor = "Editor";

//imports
const NavigationMenuPage = React.lazy(() => import("./page/NavigationMenuPage/NavigationMenuPage"));
const View1 = React.lazy(() => import("./view/View1/View1"));
const View2 = React.lazy(() => import("./view/View2/View2"));
const View3 = React.lazy(() => import("./view/View3/View3"));
const View4 = React.lazy(() => import("./view/View4/View4"));
const FormAutomation = React.lazy(() => import("./view/PageFormAutomation/PageFormAutomation"));
const Branch = React.lazy(() => import("./view/PageBranch/Branch"));
const PageMode = React.lazy(() => import("./view/PageMode/PageMode"));
const PageCreateProject = React.lazy(() => import("./view/PageCreateProject/PageCreateProject"));
const PageProjectListing = React.lazy(() => import("./view/PageProjectListing/PageProjectListing"));

const PageHost = React.lazy(() => import("./view/PageHost"));
const PageLaunch = React.lazy(() => import("./view/PageLaunch"));
const PageUploadPDF = React.lazy(() => import("./view/PageUploadPDF/PageUploadPDF"));
const PageRebateAnalysis = React.lazy(() => import("./view/PageRebateAnalysis/PageRebateAnalysis"));
const PageAudioAnalysis = React.lazy(() => import("./view/PageAudioAnalysis/PageAudioAnalysis"));
const PageUnauthorized = React.lazy(() => import("./view/PageUnauthorized"));
const PageEditor = React.lazy(() => import("./view/PageEditor"));

//routes
const routes: IRouteObj[] = [
  {
    path: linkPageMenu,
    exact: true,
    name: linkNamePageMenu,
    component: NavigationMenuPage,
  },
  {
    path: linkPageView1,
    exact: true,
    name: linkNamePageView1,
    component: View1,
  },
  { path: linkPageView2, name: linkNamePageView2, component: View2 },
  { path: linkPageView3, component: View3 },
  { path: linkPageView4, component: View4 },
  { path: linkPageCart, component: View4 },
  { path: linkPageFormNameCreate, component: FormAutomation },
  { path: linkPageFormNameView, component: FormAutomation },
  { path: linkPageBranchCreate, component: Branch },
  { path: linkPageBranchView, component: Branch },
  { path: linkPageMode, component: PageMode },
  { path: linkPageCreateProjectCreate, component: PageCreateProject },
  { path: linkPageCreateProjectView, component: PageCreateProject },
  { path: linkPageProjectListing, component: PageProjectListing },
  {
    path: linkPageHost,
    component: PageHost,
  },
  {
    path: `${linkPageHost}/:remoteName/*`,
    component: PageHost,
  },
  {
    path: linkPageLaunch,
    component: PageLaunch,
  },
  {
    path: linkPageAudioAnalysis,
    component: PageAudioAnalysis,
  },
  {
    path: linkPageUploadAudio,
    component: PageUploadAudio,
  },
  {
    path: linkPageUnauthorized,
    name: linkNamePageUnauthorized,
    component: PageUnauthorized,
  },
  {
    path: linkPageEditor,
    name: linkNamePageEditor,
    component: PageEditor,
  },
];

export default routes;
